import api from './api-v2';

const filter = async (filters) => {
    const client = await api.getClient();
    return await api.handleSuccess(await client.get('conditions', { params: filters}));
};

// filter3 reads fleet's /api/v3/conditions (clusters-fleet cutover, #5104):
// core2's v2 envelope and item shape. `clusterId` narrows to one cluster.
const filter3 = async (filters) => {
    const client = await api.getClientV3();
    return await api.handleSuccess(await client.get('conditions', { params: filters}));
};

export default {
    filter,
    filter3
};
